import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { ButtonLink } from '../General/Button';
import { __ } from 'react-i18n';

interface Props {
  image: string;
  url: string;
}

function BannerWithImgButton({ image, url }: Props) {
  return (
    <Wrapper>
      <Image alt={'Obrázok montáže krbu'} src={image} />
      <TextButtonWrapper>
        <Text>{__('Zabezpečíme odbornú montáž vášho krbu')}</Text>
        <InterestedButton to={url}>{__('Mám záujem')}</InterestedButton>
      </TextButtonWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  border: 0;
  border-radius: ${rem(2)};
  max-width: ${rem(820)};
  width: 100%;
  padding: 0;
  height: ${rem(190)};
  align-items: flex-end;

  ${({ theme }) => theme.mediab.l925`
    display: none;
  `}
`;

const Image = styled.img`
  height: ${rem(190)};
  max-width: ${rem(498)};
`;

const TextButtonWrapper = styled(FlexCol)`
  width: 50%;
  justify-content: center;
  background-color: #fbf4f2;
  height: ${rem(180)};
`;

const Text = styled(TextP)`
  font-size: ${rem(20)};
  line-height: ${rem(28)};
  font-family: ${({ theme }) => theme.font.primary};
  margin-bottom: ${rem(16)};
  max-width: ${rem(200)};
`;

const InterestedButton = styled(ButtonLink)`
  background-color: ${({ theme }) => theme.heatCategory.primary};
  color: white;
  max-width: ${rem(160)};
  border-radius: ${rem(2)};
`;

export { BannerWithImgButton };
